export default "__VITE_ASSET__9921df5e__"